export const formatAccess = (date) => {
  if (!date) return "";
  const formattedDate = new Date(date);
  const year = formattedDate.getFullYear();
  const month = (formattedDate.getMonth() + 1).toString().padStart(2, "0");
  const day = formattedDate.getDate().toString().padStart(2, "0");
  const hours = formattedDate.getHours().toString().padStart(2, "0");
  const minutes = formattedDate.getMinutes().toString().padStart(2, "0");
  const seconds = formattedDate.getSeconds().toString().padStart(2, "0");
  return `${year}.${month}.${day} ${hours}:${minutes}:${seconds}`;
};

export const formatAccessWbar = (date) => {
  if (!date) return "";
  const formattedDate = new Date(date);
  const year = formattedDate.getFullYear();
  const month = (formattedDate.getMonth() + 1).toString().padStart(2, "0");
  const day = formattedDate.getDate().toString().padStart(2, "0");
  const hours = formattedDate.getHours().toString().padStart(2, "0");
  const minutes = formattedDate.getMinutes().toString().padStart(2, "0");
  const seconds = formattedDate.getSeconds().toString().padStart(2, "0");
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

export const formatDate = (date) => {
  if (!date) return "";
  const formattedDate = new Date(date);
  const year = formattedDate.getFullYear();
  const month = (formattedDate.getMonth() + 1).toString().padStart(2, "0");
  const day = formattedDate.getDate().toString().padStart(2, "0");
  return `${year}.${month}.${day}`;
};

export const formatDateWbar = (date) => {
  if (!date) return "";
  const formattedDate = new Date(date);
  const year = formattedDate.getFullYear();
  const month = (formattedDate.getMonth() + 1).toString().padStart(2, "0");
  const day = formattedDate.getDate().toString().padStart(2, "0");
  return `${year}-${month}-${day}`;
};

// 사용자 생년월일 변경
export const formatBirthDate = (date) => {
  const digits = date.replace(/\D/g, "");
  const year = digits.slice(0, 4);
  const month = digits.slice(4, 6);
  const day = digits.slice(6, 8);

  let formattedValue = "";

  if (year) {
    formattedValue += year;
  }
  if (month) {
    formattedValue += `-${month}`;
  }
  if (day) {
    formattedValue += `-${day}`;
  }

  return formattedValue;
};

// 한국어 날짜 형식 (YYYY년 M월 D일 (요일) 오전/오후 H:MM)
export const formatKoreanDateTime = (date) => {
  if (!date) return "";
  const formattedDate = new Date(date);

  const year = formattedDate.getFullYear();
  const month = formattedDate.getMonth() + 1; // 앞의 0 제거
  const day = formattedDate.getDate(); // 앞의 0 제거

  // 요일 구하기
  const weekdays = ["일", "월", "화", "수", "목", "금", "토"];
  const weekday = weekdays[formattedDate.getDay()];

  // 시간 구하기 (오전/오후)
  let hours = formattedDate.getHours();
  const minutes = formattedDate.getMinutes().toString().padStart(2, "0");
  const ampm = hours < 12 ? "오전" : "오후";

  // 12시간제로 변환
  hours = hours % 12;
  hours = hours ? hours : 12; // 0시는 12시로 표시

  return `${year}년 ${month}월 ${day}일 (${weekday}) ${ampm} ${hours}:${minutes}`;
};
